<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      bf-header(title='Privacy')
    #privacy.view.no-header
      bf-wrapper.content
        section
          h5 Privacy Policy
          p This Privacy Policy explains how we handle the personal information that you provide to us on www.bluefaucet.com and/or its app (BlueFaucet). This Privacy Policy does not apply to personal information collected from you offline, to residents of countries other than the United States, or to third-party Web sites to which BlueFaucet may link. Your use of BlueFaucet is subject to this Privacy Policy and the Terms of Use.
          p Please read this Privacy Policy before using BlueFaucet or submitting personal information to us.

        section
          h5 How does this Privacy Policy define "personal information"?
          p "Personal information" means information that identifies you or could reasonably be used to identify you and which is submitted to and/or collected by BlueFaucet and maintained by Hi Angels Corp. in an accessible form. Examples of personal information include your name, your postal address and your telephone number.

        section
          h5 How does BlueFaucet collect information online?
          p BlueFaucet collects information in two ways:
          p
            | A. Personal Information You Submit: BlueFaucet collects personal information that you enter into data fields on BlueFaucet. For example, you
            | may submit your name, postal address, e-mail address, and/or other information in order to receive information about various subjects,
            | contact BlueFaucet customer service, or respond to BlueFaucet surveys. To protect your privacy, you should not provide BlueFaucet with any
            | information that is not specifically requested.
          p
            | B. Passive Collection of Unidentifiable Information: BlueFaucet may collect information about your visits to BlueFaucet without you actively
            | submitting such information. Unidentifiable information may be collected using various technologies, such as cookies, Internet tags, web
            | beacons and others. Your Internet browser automatically transmits to BlueFaucet some of this unidentifiable information, such as the URL of
            | the Web site you just visited and the browser version your computer is operating. Passive information collection technologies can make your
            | use of BlueFaucet easier by allowing BlueFaucet to provide better service, customize sites based on consumer preferences, compile statistics,
            | analyze trends, and otherwise administer and improve BlueFaucet. Certain features of BlueFaucet may not work without use of passive
            |information collection technologies. Information collected by these technologies cannot be used to identity you without additional identifiable information.

        section
          h5 In what circumstances might BlueFaucet collect and use personal information?
          p
            | BlueFaucet will use the personal information you provide through BlueFaucet to respond to your questions and to provide you with efficient
            | customer service. After you have entered personal information into a form or data field on BlueFaucet, BlueFaucet may use certain identifying
            | technologies to allow to &quot;remember&quot; your personal preferences, such as sections of that stores that you visit frequently and, if you choose,
            | your user ID. We may also use this personal information for other business purposes, such as to offer you the opportunity to receive notices
            | regarding BlueFaucet products or services, to invite you to participate in surveys about our products, or to notify you about special promotions.

        section
          h5 Does BlueFaucet consolidate personal information?
          p
            | BlueFaucet may consolidate the personal information of customers who use BlueFaucet. We use this information to help us better design
            | BlueFaucet products, to communicate information to you, to enhance our marketing and research activities, and to facilitate other business
            | functions.

        section
          h5 What choices do I have about how BlueFaucet collects and uses personal information about me?
          p
            | You may always limit the amount and type of personal information that BlueFaucet receives about you by choosing not to enter any personal
            | information into forms or data fields on BlueFaucet. Some of our online services can only be provided to you if you provide us with appropriate
            | personal information. Other parts of BlueFaucet may ask whether you wish to opt out or opt into our contact lists for offers, promotions and
            | additional services that may be of interest to you.
            | You may also be provided with preference questions or preference boxes allowing you to indicate that you do not want BlueFaucet to use
            | tracking technologies, such as cookies, to &quot;remember&quot; your personal information, such as user IDs or mailing addresses, on return visits. Some
            | Internet browsers allow you to limit or disable the use of tracking technologies that collect unidentifiable information.

        section
          h5 Who will have access to personal information about me?
          p
            | Personal information can be accessed by a restricted number of BlueFaucet employees and by individuals and entities with whom BlueFaucet
            | contracts to carry out business activities for BlueFaucet. We train our employees about the importance of privacy and how to handle and
            | manage customer data appropriately and securely. Also, it is BlueFaucet practice to notify you if you are registering for a program which is
            | conducted in conjunction with another company that may require access to your personal information. In addition, BlueFaucet practice is to
            | require its contractors to keep your personal information confidential and to use personal information only to perform functions for
            | BlueFaucet.

        section
          h5 Does BlueFaucet share personal information with third parties?
          p
            | As a general rule, BlueFaucet does not share your personal information with third parties, unless it is necessary to conduct a joint program or to
            | carry out a program or activity through a contractor. Where required by law, BlueFaucet will not disclose your personal information to third
            | parties for those third parties marketing purposes, unless you have been provided with an opportunity to opt into or opt out of this disclosure.
            | If BlueFaucet provides your personal information to individuals and entities which assist us with our business activities, it is BlueFaucet practice
            | to require those individuals and entities to keep your personal information confidential and to use your personal information only to perform
            | functions for BlueFaucet. BlueFaucet reserves the right to disclose your personal information to respond to authorized information requests
            | from government authorities, to address national security situations, or when otherwise required by law.

        section
          h5 How does BlueFaucet secure personal information?
          p
            | It is BlueFaucet practice to secure database that collects personal information; however, the confidentiality of personal information transmitted
            | over the Internet cannot be guaranteed. We urge you to exercise caution when transmitting personal information over the Internet, especially
            | personal information related to your health. BlueFaucet cannot guarantee that unauthorized third parties will not gain access to your personal
            | information; therefore, when submitting personal information to BlueFaucet, you must weigh both the benefits and the risks.

        section
          h5 How does BlueFaucet protect the privacy of children?
          p
            | BlueFaucet does not knowingly collect or use any personal information from children (we define &quot;children&quot; as minors younger than 13) on
            | BlueFaucet. We do not knowingly allow children to order our products, communicate with us, or use any of our online services. If you are a
            | parent and become aware that your child has provided us with information, please contact us using one of the methods specified below, and
            | we will work with you to address this issue.

        section
          h5 How may I correct personal information or delete it from current customer records?
          p
            | You may request to remove your personal information from our current customer records or to amend your personal information. Please notify
            | us of your wishes by contacting us in one of the ways specified below. For our record keeping purposes, we will retain certain personal
            | information you submit in conjunction with commercial transactions.

        section
          h5 How can I contact BlueFaucet?
          p
            | If you have questions about the use, amendment, or deletion of personal information that you have provided to us, or if you would like to opt
            | out of future communications from a BlueFaucet business or a particular program, please contact us by clicking on the &quot;Contact Us&quot; link on the
            | Web site or App you are visiting.

        section
          h5 How will I know whether BlueFaucet has updated this policy?
          p
            | BlueFaucet reserves the right to amend this Privacy Policy without prior notice to reflect technological advancements, legal and regulatory
            | changes and good business practices. If BlueFaucet changes its privacy practices, a new Privacy Policy will reflect those changes and the
            | effective date of the revised Privacy Policy will be set forth in this paragraph. This Privacy Policy was last updated on July 4, 2019 and is effective
            | as of that date.
</template>

<script>
  import { View } from '@/mixins/view'

  export default {
    name: 'view.privacy',

    mixins: [View]
  }
</script>
<style scoped lang='stylus'>
  #privacy.view
    text-align justify
    line-height 1.5
  section, p
    margin 12px 0
  section
    margin 48px 0
</style>
